import { ref } from 'vue'

export const storeIsOpen = ref(false)
